import React from 'react';
import { Link } from 'react-router-dom';
import PublicSiteShell from '../components/public/PublicSiteShell';

export default function PoliticaPrivacidad() {
  return (
    <PublicSiteShell hideFooterCta={true}>
      <div className="gst-site">
        <div className="gst-container py-16">
          <div className="mx-auto max-w-3xl overflow-hidden rounded-[2rem] border border-[var(--gst-border)] bg-[var(--surface)] p-8 shadow-[0_24px_60px_rgba(31,36,33,0.04)] md:p-12">
            <h1 className="gst-public-display text-4xl font-black text-[var(--gst-graphite-900)] mb-2">Política de Privacidad</h1>
            <p className="text-[var(--gst-mint-700)] font-bold tracking-widest uppercase text-xs mb-8">Última actualización: Marzo 2026</p>

            <div className="space-y-6 text-[var(--gst-graphite-700)] leading-relaxed">
              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight">1. Recopilación de Información</h2>
              <p>
                Recopilamos información cuando se registra en nuestro sitio, inicia sesión en su cuenta corporativa y hace uso de las herramientas de software de Gastify. La información recabada incluye su nombre, dirección de correo electrónico institucional, número de teléfono y/o datos financieros vinculados a la organización.
              </p>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">2. Uso de la Información</h2>
              <div>
                Cualquier información que recopilemos de usted puede ser utilizada para:
                <ul className="list-disc pl-5 mt-2 space-y-2">
                  <li>Personalizar y generar la estructura de su ecosistema B2B.</li>
                  <li>Mejorar nuestro sitio web y el rendimiento del algoritmo interno.</li>
                  <li>Mejorar el servicio al cliente y sus necesidades de soporte logístico.</li>
                  <li>Contactarlo mediante notificaciones automatizadas de métricas de ventas.</li>
                </ul>
              </div>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">3. Privacidad del Comercio Electrónico</h2>
              <p>
                Somos los únicos propietarios de la información recopilada en este sitio tecnológico. Sus datos de transacciones u operaciones <em>not</em> serán vendidos, intercambiados, transferidos o cedidos a ninguna otra empresa por ninguna razón corporativa.
              </p>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">4. Seguridad de la Información</h2>
              <p>
                Implementamos una gran variedad de medidas de seguridad en el backend utilizando protección de <em>Supabase</em> con políticas de RLS exclusivas por id. Para más detalles corporativos lea nuestros <Link to="/legales/terminos" className="text-[var(--gst-mint-600)] hover:text-[var(--gst-mint-700)] underline">Términos de Servicio</Link>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </PublicSiteShell>
  );
}
